// extracted by mini-css-extract-plugin
export default {"button":"GameRoomsTable_button__mCgLj","closeButton":"GameRoomsTable_closeButton__cteHW","tableRow":"GameRoomsTable_tableRow__Uo+RN"};